export default [
  {
    value: "adults",
    label: "Adults",
  },
  {
    value: "men",
    label: "Men",
  },
  {
    value: "women",
    label: "Women",
  },
  {
    value: "lGBTQ+",
    label: "LGBTQ+",
  },
  {
    value: "infants",
    label: "Infants",
  },
  {
    value: "blind",
    label: "Blind",
  },
  {
    value: "deaf",
    label: "Deaf",
  },
  {
    value: "underPrevilidged",
    label: "Under Previlidged",
  },
  {
    value: "teenagers",
    label: "Teenagers",
  },
  {
    value: "ladies",
    label: "Ladies",
  },
  {
    value: "homeless",
    label: "Homeless",
  },
  {
    value: "jobless",
    label: "Jobless",
  },
  {
    value: "orphan",
    label: "Orphan",
  },
  {
    value: "homeless",
    label: "Homeless",
  },
  {
    value: "nearHomeless",
    label: "Near Homeless",
  },
  {
    value: "notHomeless",
    label: "Not Homeless",
  },
  {
    value: "employed",
    label: "Employed",
  },
  {
    value: "unemployed",
    label: "Unemployed",
  },
  {
    value: "lowIncome",
    label: "Low Income",
  },
  {
    value: "highIncome",
    label: "High Income",
  },
  {
    value: "averageIncome",
    label: "Average Income",
  },
  {
    value: "insured",
    label: "Insured",
  },
  {
    value: "underInsured",
    label: "Under Insured",
  },
  {
    value: "notInsured",
    label: "Not Insured",
  },
  {
    value: "individual",
    label: "Individual",
  },
  {
    value: "smallFamily",
    label: "Small Family",
  },
  {
    value: "largeFamily",
    label: "Large Family",
  },
];
